import type { ILocation } from '@/types';
import type { IDealSummary } from '@/types/api';
import { MarkKind } from '../constants';
import { toDealFeatureCollection } from './dealFeatures';

export interface ClusteredMarkInput {
  locations?: ILocation[];
  deals?: IDealSummary[];
  hiddenStages?: readonly string[];
  ownerSelection?: readonly string[];
}

export function toLocationFeatures(locations: ILocation[]): GeoJSON.Feature[] {
  return locations.map((location, index) => ({
    type: 'Feature',
    id: location.id,
    geometry: {
      type: 'Point',
      coordinates: [location.coordinates.longitude, location.coordinates.latitude],
    },
    properties: {
      id: location.id,
      kind: MarkKind.LOCATION,
      // Drives symbol-sort-key: a newer pin sits on top of a coincident older one.
      sortKey: index,
    },
  }));
}

export function toClusteredMarkFeatures({
  locations = [],
  deals = [],
  hiddenStages = [],
  ownerSelection = [],
}: ClusteredMarkInput): GeoJSON.FeatureCollection {
  return {
    type: 'FeatureCollection',
    features: [
      ...toLocationFeatures(locations),
      ...toDealFeatureCollection(deals, hiddenStages, ownerSelection).features,
    ],
  };
}
